import { Alert, AlertDescription, AlertTitle } from "@devhop/ui";
import { AlertTriangle } from "lucide-react";
import { useSOPSUsage } from "../api/queries";

type SOPChangeWarningProps = {
  sopId: string;
};

export function SOPChangeWarning({ sopId }: SOPChangeWarningProps) {
  const { data: usage, isLoading } = useSOPSUsage(sopId);

  if (isLoading || !usage) {
    return null;
  }

  const hasUsage = usage.positionCount > 0 || usage.departmentCount > 0;

  if (!hasUsage) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>ຄຳເຕືອນ</AlertTitle>
      <AlertDescription>
        SOP ນີ້ຍັງມີຕໍາແໜ່ງ/ພະແນກທີ່ໃຊ້ຢູ່{" "}
        {usage.positionCount > 0 && `${usage.positionCount} ຕໍາແໜ່ງ`}
        {usage.positionCount > 0 && usage.departmentCount > 0 && " ແລະ "}
        {usage.departmentCount > 0 && `${usage.departmentCount} ພະແນກ`}.
        ການປ່ຽນແປງອາດຈະມີຜົນກະທົບຕໍ່ການເຮັດວຽກ.
      </AlertDescription>
    </Alert>
  );
}
